var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppButtonLink',{staticClass:"text-14-400",attrs:{"to":_vm.toLogin,"icon-left":"fl:arrow_left","icon-left-size":"11px","label":_vm.$t('label.backToLogin')}}),_c('q-separator',{staticClass:"q-mt-lg",attrs:{"color":"grey-2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }